// @module MHI.MHIOpenCloseBanner.Main
define('MHIOpenCloseBanner.Main.View', [
	'mhi_mhiopenclosebanner_main.tpl',
	'Backbone'
], function ( mhi_mhiopenclosebanner_main_tpl , Backbone )
{
    'use strict';

	var STATUS  = {};
		STATUS.OPEN = 'open';
		STATUS.CLOSED = 'closed';

	// @class MHI.MHIOpenCloseBanner.Main.View @extends Backbone.View
	return Backbone.View.extend({
		template: mhi_mhiopenclosebanner_main_tpl
	,	initialize: function (options) {
			var date = new Date()
			var convertedDate = this.convertTZ(date, "America/Chicago");

			var convertedDateHours = convertedDate.getHours();
			var convertedDateMinutes = convertedDate.getMinutes();
			var convertedDateDay = convertedDate.getDay();

			if ( convertedDateHours >= 8 
				&& convertedDateHours <= 16
				&& convertedDateDay != 0 
				&& convertedDateDay != 6 ) {
					this.storeStatus = STATUS.OPEN;
				} else {
					if ( convertedDateHours >= 7 
						&& convertedDateHours <= 17
						&& convertedDateDay >= 1 
						&& convertedDateDay <= 5 ) {
							if ( convertedDateHours == 7 && convertedDateMinutes <= 30 ) this.storeStatus = STATUS.CLOSED;
							else this.storeStatus = STATUS.OPEN;
						
							if ( convertedDateDay == 1 || convertedDateDay == 2 ) {
								if ( convertedDateHours == 17 && convertedDateMinutes >= 30 ) this.storeStatus = STATUS.CLOSED;
								//else this.storeStatus = STATUS.OPEN;
							} else if ( convertedDateDay >= 3 && convertedDateDay <= 5 ) {
								if ( convertedDateHours == 17 && convertedDateMinutes >= 0 ) this.storeStatus = STATUS.CLOSED;
								//else this.storeStatus = STATUS.OPEN;
							}
					} else {
						this.storeStatus = STATUS.CLOSED;
					}
				}
		}

	,	convertTZ: function convertTZ(date, tzString) {
			return new Date( (typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}) );   
		}

		//@method getContext @return MHI.MHIOpenCloseBanner.Main.View.Context
	,	getContext: function getContext()
		{
			//@class MHI.MHIOpenCloseBanner.Main.View.Context
			this.storeStatus = this.storeStatus;
			return {
				storeStatus: this.storeStatus
			};
		}
	});
});
